module.exports = __webpack_public_path__ + "static/img/cycleAI-75.eee845d.svg";